import { render, staticRenderFns } from "./TicketTypes.vue?vue&type=template&id=53aaa04d&scoped=true&"
import script from "./TicketTypes.vue?vue&type=script&lang=js&"
export * from "./TicketTypes.vue?vue&type=script&lang=js&"
import style0 from "./TicketTypes.vue?vue&type=style&index=0&id=53aaa04d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aaa04d",
  null
  
)

export default component.exports